import React, { useEffect, useState } from 'react'
import './Services.css'
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import LocalGasStationTwoToneIcon from '@mui/icons-material/LocalGasStationTwoTone';
import { Button } from '@mui/material';
import CarSelection from './CarSelection';
import ServiceCatalogue from './ServiceCatalogue';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';


function Services() {
  const [carDialog, setCarDialog] = React.useState(false);
  // const [brandID, setbrandID] = useState(null)
  const [selectedCarData, setSelectedCarData] = useState(null);
  // const [storedCarDtl, setstoredCarDtl] = useState('')
  const navigate = useNavigate();

  useEffect(() => {
    // GET CAR DETAILS FROM LOCAL STORAGE
    const storedData = localStorage.getItem('storedCarDetails')

    if (storedData && storedData !== "undefined") {
      const parsedData = JSON.parse(storedData)
      //STORE THE DATA GETTING FROM BRAND, CAR NAME & VARIANT
        setSelectedCarData(parsedData)
        console.log(storedData, "LOL")
    }else{
      localStorage.removeItem("storedCarDetails")
      setSelectedCarData(null)
    }
  }, [])


  const handleCarSelection = (data) => {
    console.log(data, "Lllllllll")
    setCarDialog(true);
    if (data?.brand && data?.model && data?.fuel) {
      setSelectedCarData(data);
      setCarDialog(false);
      localStorage.setItem("storedCarDetails", JSON.stringify(data))
    } else {
      // Else keep dialog open
      console.warn("Incomplete data. Dialog will stay open.");
      Swal.fire({
        icon: "warning",
        title: "Please complete all selections before closing.",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
      });
    }
    // setCarDialog(!carDialog);
  };

  return (
    <>
      <div className='serviceContainer'>
        <div className='container'>
          <div className='vehicleSelection'>
            <div style={{ display: 'flex', alignItems: 'center' }} className='serviceHeading'>
              <IconButton color="primary" aria-label="back" onClick={() => navigate('/')}>
                <KeyboardBackspaceTwoToneIcon fontSize="large" />
              </IconButton>
              <h3 style={{ marginLeft: '10px', color: '#1d397e' }}> Pick From the Below Services </h3>
            </div>

            {selectedCarData ?
              <>
                <div className='selectedcarTab'>
                  <img src={selectedCarData.logo} alt='Car' />
                  <div className='brandType'>
                    <div className='info'>
                      <h4>{selectedCarData.model}</h4>
                      <p>{selectedCarData.brand} |
                        <span> <LocalGasStationTwoToneIcon fontSize="small" />{selectedCarData.fuel} </span>
                      </p>
                    </div>
                    <Button variant="contained" color='secondary' startIcon={<EditTwoToneIcon />} onClick={handleCarSelection}> Edit </Button>
                  </div>
                </div>
              </>
              :
              <Button variant="outlined" onClick={handleCarSelection}> Select Vehicle </Button>
            }
          </div>

          {/* CAR SELECTION DIALOG BOX */}
          <CarSelection carDialog={carDialog} setCarDialog={setCarDialog} handleCarSelection={handleCarSelection} />



          <div className='serviceCategories'>
            <div className='serviceCont'>
              <h6> Our Curated </h6>
              <h1> Services </h1>
            </div>
            {selectedCarData ?
              <ServiceCatalogue />
              :
              <h3 style={{ textAlign: 'center', color: '#bbbaba', fontWeight: '700', marginBottom: '7rem', marginTop: '2rem' }}>
                Kindly select a vehicle in order to view our services
              </h3>
            }
          </div>
        </div>
      </div >
    </>
  )
}

export default Services